import * as Sentry from '@sentry/vue'
import crypto from 'crypto'
import store from '@/store'

export const decipher = (secureToken, IVKey) => {
  const secureTokenB64 = secureToken.replace(/_/g, '/').replace(/-/g, '+')
  const jti = JSON.parse(
    atob(store.getters.token.split('.')[1])
  ).jti
  const jtiHash = crypto.createHash('sha256').update(jti).digest()
  const iv = IVKey

  Sentry.setContext('keys', {
    iv: iv,
    jti: jti,
    token: secureTokenB64
  })

  const decipher = crypto.createDecipheriv('aes-256-cbc', jtiHash, iv)
  const dec = decipher.update(secureTokenB64, 'base64', 'utf8')
  const jsonData = JSON.parse(dec + decipher.final('utf8'))

  return jsonData
}
export const decipherv2 = (secureToken, IVKey, jti) => {
  const secureTokenB64 = secureToken.replace(/_/g, '/').replace(/-/g, '+')
  const jtiHash = crypto.createHash('sha256').update(jti).digest()
  const iv = IVKey

  Sentry.setContext('keys', {
    iv: iv,
    jti: jti,
    token: secureTokenB64
  })

  const decipher = crypto.createDecipheriv('aes-256-cbc', jtiHash, iv)
  const dec = decipher.update(secureTokenB64, 'base64', 'utf8')
  const jsonData = JSON.parse(dec + decipher.final('utf8'))

  return jsonData
}

export const encrypt = (jsonData, IVKey) => {
  const jti = JSON.parse(
    atob(store.getters.token.split('.')[1])
  ).jti
  const jtiHash = crypto.createHash('sha256').update(jti).digest()
  const iv = IVKey

  const cipher = crypto.createCipheriv('aes-256-cbc', jtiHash, iv)
  const encrypted = cipher.update(JSON.stringify(jsonData), 'utf8', 'base64') + cipher.final('base64')

  return encrypted.replace(/\+/g, '-').replace(/\//g, '_')
}

export const encryptv2 = (jsonData, IVKey, jti) => {
  const jtiHash = crypto.createHash('sha256').update(jti).digest()
  const iv = IVKey

  const cipher = crypto.createCipheriv('aes-256-cbc', jtiHash, iv)
  const encrypted = cipher.update(JSON.stringify(jsonData), 'utf8', 'base64') + cipher.final('base64')

  return encrypted.replace(/\+/g, '-').replace(/\//g, '_')
}
